import type { ApiPreferredListingType } from '#/api/types/ApiPreferredListingType';
import type { IconName } from '#/components/Icon/IconName';
import type { I18nFn } from '#/i18n/types/I18nFn';

export function getPreferredListingTypes(
  i18n: I18nFn,
  businessOnlyUser: boolean,
): {
  iconName: IconName;
  value: ApiPreferredListingType;
  label: string;
}[] {
  const preferedListingTypes: {
    iconName: IconName;
    value: ApiPreferredListingType;
    label: string;
  }[] = [
    {
      iconName: 'stairs',
      value: 'JOB',
      label: i18n('Jobs'),
    },
    {
      iconName: 'sign-path',
      value: 'INTERNSHIP',
      label: i18n('Internships'),
    },
    {
      iconName: 'cloud-bubble',
      value: 'NOT_SURE',
      label: i18n("I'm not sure"),
    },
    {
      iconName: 'computer',
      value: 'NOT_HERE_TO_POST',
      label: i18n("I'm not here to post"),
    },
  ];
  if (!businessOnlyUser) {
    preferedListingTypes.splice(2, 0, {
      iconName: 'parachute',
      value: 'VOLOP',
      label: i18n('Volunteer Opportunities'),
    });
  }
  preferedListingTypes.splice(businessOnlyUser ? 2 : 3, 0, {
    iconName: 'calendar',
    value: 'EVENT',
    label: i18n('Events'),
  });
  return preferedListingTypes;
}
